export interface ICommand { }

export class SetLifecycleCompletedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleCompletedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleCompletedCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleInProgressCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleInProgressCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	StartDate: any

	constructor (workspaceId: number, portfolioId: string, id: string, startDate: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.StartDate = startDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleInProgressCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecyclePausedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecyclePausedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecyclePausedCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleProposalCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleProposalCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleProposalCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleQualifiedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleQualifiedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleQualifiedCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleRejectedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleRejectedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleRejectedCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleResumedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleResumedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleResumedCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleScheduledCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleScheduledCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	StartDate: any

	constructor (workspaceId: number, portfolioId: string, id: string, startDate: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.StartDate = startDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleScheduledCommandV1, TCh.Domain.Quest'
	}

}

export class SetLifecycleTerminatedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.SetLifecycleTerminatedCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.SetLifecycleTerminatedCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectActivePlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Projects.Commands.UpdateProjectActivePlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectPlanId: string

	constructor (userId: number, workspaceId: number, portfolioId: string, id: string, projectPlanId: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectPlanId = projectPlanId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Projects.Commands.UpdateProjectActivePlanCommandV1, TCh.Domain.Quest'
	}

}

